import isEqual from 'lodash/fp/isEqual';
import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions';
import type { OriginalState, State } from './types';
import { toDraft } from './utils';

const initialState: State = {
	isIssueLinkingEnabled: false,
	issueLinkTypes: {},
	issueLinkTypeIds: [],
	dependencies: {},
	dependencyIds: [],
	draft: [],
	savingInProgress: false,
};

const store = createStore({
	initialState,
	actions,
	name: 'DependencySettingsPage',
});

export const Provider = createContainer(store, {
	onInit:
		() =>
		// eslint-disable-next-line @typescript-eslint/no-shadow
		({ setState }, { initialState }: { initialState: OriginalState }) => {
			const { dependencies, dependencyIds } = initialState;

			setState(initialState);
			setState({ draft: toDraft(dependencyIds, dependencies) });
		},
});

export const useDraft = createHook(store, {
	selector: ({ draft }) => draft,
});

export const useIssueLinkType = createHook(store, {
	selector: ({ issueLinkTypes }, { id }: { id: number }) => issueLinkTypes[id],
});

export const useAvailableIssueLinkTypes = createHook(store, {
	selector: ({ issueLinkTypes, issueLinkTypeIds, draft }) =>
		issueLinkTypeIds
			.filter((id) => draft.every((dependency) => dependency.issueLinkTypeId !== id))
			.map((id) => issueLinkTypes[id])
			.filter((one) => one !== undefined),
});

export const useSavingInProgress = createHook(store, {
	selector: ({ savingInProgress }) => savingInProgress,
});

export const useFormState = createHook(store, {
	selector: ({ dependencyIds, dependencies, draft, savingInProgress }) => ({
		modified: !isEqual(draft, toDraft(dependencyIds, dependencies)),
		savingInProgress,
	}),
});
